var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableGamesFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.18 21.695c.09-.046.178-.094.264-.144l.002-.001c-.087.05-.176.1-.266.145z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 9.56a7.125 7.125 0 110 14.25 7.125 7.125 0 010-14.25zm2.669 10.59a4.35 4.35 0 01-2.107.873v1.255a5.5 5.5 0 01-.562.033c.19 0 .378-.011.563-.03v-.003c.044-.004.088-.007.131-.012l-.072.008a5.608 5.608 0 003.624-1.903l-.005-.005c-.209.243-.435.47-.683.673l-.89-.889zm.89.89a4.962 4.962 0 01-.001 0zm-9.146-3.706l-.008-.073c.012.119.028.237.047.353l.037.205c.16.779.482 1.497.928 2.121l.898-.897a4.348 4.348 0 01-.653-1.795H11.03l-.005-.039.014.125zm5.587-3.524a2.875 2.875 0 100 5.75 2.875 2.875 0 000-5.75zm3.463.205c.388.502.67 1.09.81 1.733h1.27a5.592 5.592 0 00-1.19-2.622l-.89.889zm-4.4-2.876a5.594 5.594 0 00-2.322.963l.9.899a4.35 4.35 0 011.421-.589V11.14z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.549 2a1 1 0 011 1v5.626a8.639 8.639 0 00-3.322 2.274c.014-.086.023-.175.023-.266 0-.657-.492-1.18-.75-1.445L8 7.614c-.145-.152-.347-.152-.5 0-.153.153-1.516 1.583-1.516 1.583l-.023.026c-.243.263-.71.77-.711 1.41 0 .789.563 1.445 1.375 1.445.197 0 .372-.033.528-.092l-.36 1.514H8.61a8.597 8.597 0 00-.348 5.297H3a1 1 0 01-1-1V3a1 1 0 011-1h9.549z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.347 11.974a1.373 1.373 0 001.054.001 8.6 8.6 0 00-.73 1.367l-.324-1.368z",
    fill: "currentColor"
  })));
}
SvgTableGamesFilled.displayName = 'TableGamesFilled';
export default SvgTableGamesFilled;